.row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.notes {
  display: inline-flex;
  gap: var(--tuna-spacing-1);
  flex-wrap: wrap;
}

.note {
  padding: 4px var(--tuna-spacing-1);
  border-radius: var(--tuna-shape-borderRadius);
  font-family: ui-monospace, monospace;
}

.noteCharacteristic {
  composes: note;
  background: var(--tuna-palette-warning-light);
  color: var(--tuna-palette-warning-contrastText);
  font-weight: bold;
}

@media (prefers-reduced-motion: no-preference) {
  .noteCharacteristic {
    transition: background 200ms ease-in-out;
  }
}

.caption {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
  margin: 0;
}
